var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CreateAllowanceNotification',{attrs:{"notification":_vm.notification},on:{"click":function($event){return _vm.$emit('click', _vm.notification)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }